import Empresa from "./modulos/Empresa";
import Servico from "./modulos/Servico";
import Ocorrencia from "./modulos/Ocorrencia";
import Usuario from "./modulos/Usuario";

require('./bootstrap');

console.clear();

require('../../node_modules/bootstrap4-toggle/js/bootstrap4-toggle.min');

const Chart = require('../../node_modules/chart.js/dist/Chart');
const Chartist = require('../../node_modules/chartist/dist/chartist');
require('../../node_modules/chartist-plugin-tooltips/dist/chartist-plugin-tooltip');
require('../../node_modules/select2/dist/js/select2.full.js');
require('../../node_modules/select2/dist/js/select2.js');
require('./vendor/timepicker');

const c3 = require('../../node_modules/c3/c3');

jQuery(function () {

  $(document).on('input', '[data-cnae-search]', function () {
    if (!/^[0-9.\/\-\s]*$/.test(this.value)) {
      return;
    }

    const digits = this.value.replace(/\D/g, '').slice(0, 7);

    if (digits.length <= 4) {
      this.value = digits;
      return;
    }

    if (digits.length === 5) {
      this.value = `${digits.slice(0, 4)}-${digits.slice(4)}`;
      return;
    }

    this.value = `${digits.slice(0, 4)}-${digits.slice(4, 5)}/${digits.slice(5)}`;
  });


  if ($(".select2").length > 0) {

    $(".select2").select2();

    $("#cnae").closest('.form-group').addClass('focused');
    $("#cnaes").closest('.form-group').addClass('focused');
    $("#codigos_iss").closest('.form-group').addClass('focused');
    $("#natureza_juridica").closest('.form-group').addClass('focused');
    $("#regime_tributario").closest('.form-group').addClass('focused');

    $("#cnae").select2({
      placeholder: 'Selecione'
    });

    $("#cnaes").select2({
      placeholder: 'Selecione vários'
    });

    $("#codigos_iss").select2({
      placeholder: 'Selecione vários'
    });

    $("#natureza_juridica").select2({
      placeholder: 'Selecione'
    });
  }

  $.ajaxSetup({
    headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
  });

  /**
   * Popula os dados do grafico de ocorrencias para os últimos dias.
   *
   * @param {*} ocorrenciasUltimosDias
   */
  function chartOcorrenciasUltimosDias(ocorrenciasUltimosDias) {
    //#/

    const values = ocorrenciasUltimosDias.data;
    const labels = [];
    let i = 0;
    ocorrenciasUltimosDias.labels.forEach(label => {
      labels.push(`${values[i]} ${label}`);
      i++;
    });

    const $chartOcorrenciasUltimosDias = $('#chartOcorrenciasUltimosDias');
    const $chartOcorrenciasUltimosDiasContainer = $('#chartOcorrenciasUltimosDiasContainer');

    if ($chartOcorrenciasUltimosDias.length) {
      //#/
      $chartOcorrenciasUltimosDias
        .parent()
        .find('.no-data')
        .remove();

      $('#loadingChartOcorrenciasULtimosDias').hide();
      $('#chartOcorrenciasUltimosDias').remove();
      $chartOcorrenciasUltimosDiasContainer.append(
        '<canvas id="chartOcorrenciasUltimosDias"></canvas>'
      );

      if (ocorrenciasUltimosDias.labels.length === 0) {
        $chartOcorrenciasUltimosDias.hide();
        $chartOcorrenciasUltimosDias.parent().prop('style', '');
        $chartOcorrenciasUltimosDiasContainer.prepend(`
          <p class="no-data alert alert-info" style="font-size: 16px;">
          <i class="mdi mdi-information"></i>
          Não há dados para o serviço ou período selecionados.
          </p>
        `);
        return;
      }

      $chartOcorrenciasUltimosDias.show();

      const ctx = $('#chartOcorrenciasUltimosDias');
      const myChart = new Chart(ctx, {
        type: 'doughnut',
        responsive: true,
        data: {
          labels: labels,
          datasets: [
            {
              label: '# de Ocorrências',
              data: ocorrenciasUltimosDias.data,
              backgroundColor: [
                'rgb(116, 90, 242)',
                'rgb(30, 136, 229)',
                'rgb(38, 198, 218)',
                'rgb(255, 159, 64)'
              ],
              borderColor: [
                'rgb(116, 90, 242)',
                'rgb(30, 136, 229)',
                'rgb(38, 198, 218)',
                'rgb(255, 159, 64)'
              ],
              borderWidth: 1
            }
          ]
        },
        options: {
          legend: {
            position: 'right'
          }
        }
      });

      myChart.canvas.parentNode.style.marginTop = '0';
    }
  }

  /**
   * Popula os dados do grafico de lançamentos de serviços para os últimos dias.
   *
   * @param {*} lancamentosUltimosDias
   */
  function chartLancamentosUltimosDias(lancamentosUltimosDias) {
    //#/
    const $chartLancamentosUltimosDias = $(
      '#chartLancamentosUltimosDias'
    );

    const $chartLancamentosUltimosDiasContainer = $('#chartLancamentosUltimosDiasContainer');

    if ($chartLancamentosUltimosDias.length) {
      //#/
      $chartLancamentosUltimosDias
        .parent()
        .find('.no-data')
        .remove();

      $('#loadingChartLancamentosULtimosDias').hide();
      $('#chartLancamentosUltimosDias').remove();
      $chartLancamentosUltimosDiasContainer.append(
        '<canvas id="chartLancamentosUltimosDias"></canvas>'
      );

      if (lancamentosUltimosDias.labels.length === 0) {
        $chartLancamentosUltimosDias.hide();
        $chartLancamentosUltimosDias.parent().prop('style', '');
        $chartLancamentosUltimosDiasContainer.prepend(`
          <p class="no-data alert alert-info" style="font-size: 16px;">
          <i class="mdi mdi-information"></i>
         Não há dados para o período selecionados.
          </p>
          `);
        return;
      }

      $chartLancamentosUltimosDias.show();

      const ctx = $('#chartLancamentosUltimosDias');

      let totalLucroPresumido = 0;
      lancamentosUltimosDias.datasets['Lucro Presumido'].data.forEach(item => totalLucroPresumido += parseInt(item));
      let totalLucroReal = 0;
      lancamentosUltimosDias.datasets['Lucro Real'].data.forEach(item => totalLucroReal += parseInt(item));
      let totalSimplesNacional = 0;
      lancamentosUltimosDias.datasets['Simples Nacional'].data.forEach(item => totalSimplesNacional += parseInt(item));
      let totalSIMEI = 0;
      lancamentosUltimosDias.datasets['SIMEI'].data.forEach(item => totalSIMEI += parseInt(item));

      const myChart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: lancamentosUltimosDias.labels,
          datasets: [
            {
              fill: false,
              label:
                `Lucro Presumido`,
              data: lancamentosUltimosDias.datasets['Lucro Presumido'].data,
              backgroundColor: 'rgb(116,90,242)',
              borderColor: 'rgb(116,90,242)'
            },
            {
              fill: false,
              label: `Lucro Real`,
              data: lancamentosUltimosDias.datasets['Lucro Real'].data,
              backgroundColor: 'rgb(30,136,229)',
              borderColor: 'rgb(30,136,229)'
            },
            {
              fill: false,
              label: `Simples Nacional`,
              data: lancamentosUltimosDias.datasets['Simples Nacional'].data,
              backgroundColor: 'rgb(38,198,218)',
              borderColor: 'rgb(38,198,218)'
            },
            {
              fill: false,
              label: `SIMEI`,
              data: lancamentosUltimosDias.datasets['SIMEI'].data,
              backgroundColor: 'rgb(255, 159, 64)',
              borderColor: 'rgb(255, 159, 64)'
            }
          ]
        },
        options: {
          legend: {
            position: 'bottom'
          }
        }
      });
    }
  }

  const urlJsonDashboard = '/dashboard.json';

  /**
   * Carrega as informações dinâmicas iniciais via JSON.
   */
  function loadDashboard(urlJsonDashboard) {
    $.getJSON(urlJsonDashboard).done(data => {

      if (window.location.pathname !== '/') return;

      chartOcorrenciasUltimosDias(data.ocorrenciasUltimosDias);
      chartLancamentosUltimosDias(data.lancamentosUltimosDias);
    });
  }

  /**
   * Recarrega o gráfico de Midia dos Leads para
   * os últimos dias ao clicar no ícone de reload.
   */
  $(document).on('click', '#reloadChartOcorrenciasUltimosDias', function () {
    //#/
    const totalDias = $('#selectTotalDiasOcorrencia').val();

    $('#loadingChartOcorrenciasULtimosDias').show();

    $.getJSON(
      `${urlJsonDashboard}?totalDias=${totalDias}&partial=ocorrenciasUltimosDias`
    ).done(data => {
      chartOcorrenciasUltimosDias(data.ocorrenciasUltimosDias);
    });
  });

  /**
   * Recarrega o gráfico de Qualificação dos Leads para
   * os últimos dias ao clicar no ícone de reload.
   */
  $(document).on('click', '#reloadchartLancamentosUltimosDias', function () {
      //#/
      const totalDias = $('#selectTotalDiasLancamento').val();
      const servico = $('#selectServicoLancamento').val();

      $('#loadingChartLancamentosULtimosDias').show();

      $.getJSON(
        `${urlJsonDashboard}?servico=${servico}&totalDias=${totalDias}&partial=lancamentosUltimosDias`
      ).done(data => {
        chartLancamentosUltimosDias(data.lancamentosUltimosDias);
      });
    }
  );

  $(document).on('change', '#selectServicoLancamento', function () {
    //#/
    const totalDias = $('#selectTotalDiasLancamento').val();
    const servico = $(this).val();

    $('#loadingChartLancamentosULtimosDias').show();

    $.getJSON(
      `${urlJsonDashboard}?servico=${servico}&totalDias=${totalDias}&partial=lancamentosUltimosDias`
    ).done(data => {
      chartLancamentosUltimosDias(data.lancamentosUltimosDias);
    });
  });

  $(document).on('change', '#selectTotalDiasOcorrencia', function () {
    //#/
    const totalDias = $(this).val();

    $('#totalDiasMidia').html(totalDias);
    $('#loadingChartOcorrenciasULtimosDias').show();

    $.getJSON(
      `${urlJsonDashboard}?totalDias=${totalDias}&partial=ocorrenciasUltimosDias`
    ).done(data => {
      chartOcorrenciasUltimosDias(data.ocorrenciasUltimosDias);
    });
  });

  $(document).on('change', '#selectTotalDiasLancamento', function () {
    //#/
    const totalDias = $(this).val();
    const servico = $('#selectServicoLancamento').val();

    $('#totalDiasLancamento').html(totalDias);
    $('#loadingChartLancamentosULtimosDias').show();

    $.getJSON(
      `${urlJsonDashboard}?servico=${servico}&totalDias=${totalDias}&partial=lancamentosUltimosDias`
    ).done(data => {
      chartLancamentosUltimosDias(data.lancamentosUltimosDias);
    });
  });

  $(document).on('submit', '#formPerfil', function (e) {
    e.preventDefault();

    const $name = $('#nome');
    const $picture = $('#imagem');

    const data = {};

    if ($name.val().trim().length < 3) {
      $name.focus();
      return false;
    }

    data['nome'] = $name.val().trim();

    if ($picture.val().length > 0) {
      data['imagem'] = $picture.val();
    }

    $.ajax({
      type: 'POST',
      url: '/contas/perfil',
      data
    }).done(response => {
      if (response.imagem.length > 4) {
        $('.profile-pic').prop('src', response.imagem)
        $('.profile-thumb').prop('src', response.imagem)
      }
      Swal.fire(
        'Alterado!',
        `O perfil foi alterado com sucesso!`,
        'success'
      );
    }).fail(response => {
      Swal.fire(
        'Erro!',
        `Não foi possível alterar o perfil!`,
        'error'
      );
    });
  });

  /**
   * Ações realizadas na tela de login.
   */
  function listenLoginActions() {
    const loadingMessage = `<i class="mdi mdi-spin mdi-loading"></i> Aguarde... `;

    $(document).on('click focus', 'input', function () {
      $('#loginMessage')
        .addClass('d-none')
        .html('');
    });

    /**
     * Formulário de Login
     */
    $('#loginForm').submit(function (event) {
      event.preventDefault();

      const $loginMessage = $('#loginMessage');

      $loginMessage.removeClass('d-none').html(loadingMessage);

      $.ajax({
          url: '/login',
          type: 'POST',
          data: {
            email: $('#email').val(),
            password: $('#senha').val()
          },
          headers: {}
        })
        .done(response => {
          $loginMessage.html(`
            <strong class="text-success">
            <i class="mdi mdi-check"></i> Redirecionando...
            </strong>
          `);
          window.location = '/';
        })
        .fail(response => {
          if (response.status === 422) {
            $loginMessage.html(`
              <strong class="text-danger">
              <i class="mdi mdi-block-helper"></i> Credenciais inválidas!
              </strong>
            `);
          }
        });
    });

    /**
     * Formulário de Recuperação de Senha
     */
    $('#resetForm').submit(function (event) {
      event.preventDefault();
      const $recoverMessage = $('#recoverMessage');

      $recoverMessage.removeClass('d-none').html(loadingMessage);

      setTimeout(() => {
        $recoverMessage.html(`
        <strong class="text-danger">
        <i class="mdi mdi-block-helper"></i> Sua organização não habilitou a recuperação de senha.
        </strong>
      `);
      }, 2000);
    });
  }

  if (window.location.pathname !== '/login') {
    loadDashboard(urlJsonDashboard);
  }

  if (window.location.pathname === '/login') {
    listenLoginActions();
  }

  // Para evitar usar a merda do Datatables,
  // Esse efeito de scroll após 0 segundos,
  // simula a paginação no mesmo lugar da página
  if (window.location.search.length > 0 && $("#tableBody").length > 0) {
    $('html, body').animate({
      scrollTop: $("#tableBody").offset().top - 120
    }, 0);
  }
  if (window.location.search.length > 0 && $("#tableAlertMessage").length > 0) {
    $('html, body').animate({
      scrollTop: $("#tableAlertMessage").offset().top - 120
    }, 0);
  }

  Empresa.listen();
  Servico.listen();
  Ocorrencia.listen();
  Usuario.listen();
});
